import React from 'react';
import PropTypes from 'prop-types';

// Para remover acentuação e caracteres especiais do ID foi utilizado o código encontrado nesta página: https://www.horadecodar.com.br/2021/11/29/remover-acento-em-string-com-javascript/

class PlanetCard extends React.Component {
  render() {
    const { planetName, planetImage } = this.props;
    return (
      <div
        className="planet-card"
        data-testid="planet-card"
        id={ `card-${planetName
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')}` }
      >
        <img src={ planetImage } alt={ `Planeta ${planetName}` } />
        <p data-testid="planet-name">{ planetName }</p>
      </div>
    );
  }
}

PlanetCard.propTypes = {
  planetName: PropTypes.string,
  planetImage: PropTypes.string,
}.isRequired;

export default PlanetCard;
